import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { Company } from '../models/company.model';
import { CreateCompanyDto } from '../models/dtos/createCompany.dto';
import { RestResponse } from '../models/restResponse.mode';
import { PaginatedList } from '../models/paginatedList.model';
import { environment } from '../../environments/environment';

@Injectable({
  providedIn: 'root'
})
export class CompanyService {
  private readonly baseUrl = `${environment.base_url}/companies`;

  constructor(private http: HttpClient) {}

  getAll(): Observable<RestResponse<Company[]>> {
    return this.http.get<RestResponse<Company[]>>(`${this.baseUrl}`);
  }

  create(dto: CreateCompanyDto): Observable<RestResponse<Company>> {
    return this.http.post<RestResponse<Company>>(`${this.baseUrl}/create`, dto);
  }

  update(id: number, company: Company): Observable<RestResponse<Company>> {
    return this.http.put<RestResponse<Company>>(`${this.baseUrl}/update/${id}`, company);
  }

  find(id: number): Observable<RestResponse<Company>> {
    return this.http.get<RestResponse<Company>>(`${this.baseUrl}/find/${id}`);
  }

  list(search: string = '', active: boolean = true, page: number = 1): Observable<RestResponse<PaginatedList<Company[]>>> {
    const params: any = { page };
    if (search) params.search = search;
    if (active !== undefined) params.active = active;
    return this.http.get<RestResponse<PaginatedList<Company[]>>>(`${this.baseUrl}/list`, { params });
  }

  delete(id: number): Observable<RestResponse<object>> {
    return this.http.delete<RestResponse<object>>(`${this.baseUrl}/delete/${id}`);
  }
}
